import { render } from "./FiltersList.vue?vue&type=template&id=2c9f2e14&scoped=true&ts=true"
import script from "./FiltersList.vue?vue&type=script&lang=ts"
export * from "./FiltersList.vue?vue&type=script&lang=ts"

import "./FiltersList.vue?vue&type=style&index=0&id=2c9f2e14&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c9f2e14"]])

export default __exports__